<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Settings</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Site Name"
                        name="siteName"
                        type="textarea"
                        placeholder="Site Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.siteName">
            </base-input>
          </b-col>
          <b-col md="12">
            <base-input label="Site Text"
                        name="siteTitle"
                        type="textarea"
                        placeholder="Site Text"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.siteTitle">
            </base-input>
          </b-col>
          <b-col md="12">
            <h6 class="heading-small text-muted">Company Logo Image</h6>
            <p class="h5 font-weight-300 mb-4">Logo Images are cropped into a [...]. Recommended filesize is at least [...]px.</p>
            <div class="pl-lg-4">
              <b-row>
                <b-col md="12">
                  <div class="dropzone-icon">
                  <div v-show="loadingImages" class="loading">
                    <loading-panel></loading-panel>
                  </div>
                    <vue2Dropzone
                      v-on:vdropzone-file-added="fileAdded"
                      v-on:vdropzone-max-files-exceeded="maxFileExceeded"
                      id="logoUpload"
                      :options="dropzoneOptions"
                      v-show="!loadingImages"
                      ref="logoUpload"
                    />
                </div>
              </b-col>
              </b-row>
            </div>
          </b-col>
          
        </div>
        <base-button type="primary" native-type="submit">Save Settings</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import vue2Dropzone from 'vue2-dropzone'
  import LoadingPanel from '../../components/LoadingPanel.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/clients/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditSettings",
    components: {
        vue2Dropzone,
        LoadingPanel,
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
      return {
        model: {
          id: '',
          name: '',
          iconId: '0215cb06-0ebb-4b17-098d-08d9269dc513',
          icon: '',
          isDietary: false,
          isActive: true,
          isDeleted: false,
          isVisible: true,
        },
        loadingImages: true,
        logoUpload: [],
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          uploadMultiple: false,
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          maxFiles: 1,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        if (this.model.id) {

          if ( this.$refs.logoUpload.dropzone.files[0] ) {
            this.model.logoUpload = this.$refs.logoUpload.dropzone.files[0];
          }

          try {
              dispatch("settings/updateSettings", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Settings Updated'});
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: settings edit", error);
          }
        }
      },
      loadImageToDropzones() {
        if (this.model.logo) {
          var mockFile = { name: this.model.logo.name, size: 50000, type: 'image', id: this.model.logo.id, ref: 'logoUpload'};
          this.$refs.logoUpload.manuallyAddFile(mockFile, this.model.logo.absoluteUri);
        }
      },
      getSettings(id) {
        return apiClient.get(`${id}/settings`);
      },
      maxFileExceeded(file) {
        
        this.$refs[file.ref].removeAllFiles()
        this.$refs[file.ref].addFile(file)

        this[file.ref]=[]
        this[file.ref].push(file)
      },
      fileAdded(file) {
        this[file.ref]=[]
        this[file.ref].push(file)
      }
    },
    computed: {
    },
    created() {
      this.model.id = this.$route.params.id;
      this.getSettings(this.model.id)
        .then(response => {
          this.model = response.data;
          setTimeout(() => {
            this.loadImageToDropzones();
            this.loadingImages = false;
          }, 1000);
        })
        .catch(error => {
          console.log(error)
        });
    },
    mounted() {
      
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
